// utils/getObjectById.js
//
// Scene'de userData.id'ye göre obje bul. Mesh-FP mimarisinde tesisat
// (panel, makine, vd.) fpMesh > tesisat zincirinde (scene direct child değil);
// bu yüzden scene.children.find çalışmaz — scene.traverse ile derin arama gerekli.
export const getObjectById = (scene, id) => {
  if (!scene || !id) return null;
  let found = null;
  scene.traverse((obj) => {
    if (!found && obj.userData?.id === id) found = obj;
  });
  return found || null;
};
